import moment from 'moment'

class Callbacks {
  static getEmptyFormHandler(user_id) {
    return function getEmptyForm() {
      return {
        createdAt: moment().format(),
        operator: user_id
      }
    }
  }
  static filterToFormHandler() {
    return function filterToForm(filter) {
      return {
        ...filter
      }
    }
  }
  static filterToStateHandler() {
    return function filterToState(state) {
      return {
        ...state
      }
    }
  }
  static formToFilterHandler(record_id) {
    return function formToFilter(values, extra, meta, state) {
      return {
        driver: record_id
      }
    }
  }
  static recordToFormHandler() {
    return function recordToForm(record) {
      return {
        ...record
      }
    }
  }
  static formToRecordHandler(record_id) {
    return function formToRecord(values, extra, meta) {
      return {
        reason: values?.reason,
        operator: values?.operator,
        driver: record_id,
        customer: values?.customer?.user_id
      }
    }
  }
}

export default Callbacks
